import { useMatch } from 'react-router-dom';
import { QUIZ_IDS } from '../config/funnels';

const useRouteIds = (): {
  quizIdFromRoute: QUIZ_IDS;
  userIdFromRoute: string;
} => {
  const matchTypeQuizId = useMatch('/:type/:quizId');
  const matchTypeQuizIdUserId = useMatch('/:type/:quizId/:userId/:page');

  let currentRoute: { userId: string; quizId: string | undefined } = {
    userId: '',
    quizId: '',
  };

  if (matchTypeQuizIdUserId !== null) {
    currentRoute = {
      userId: matchTypeQuizIdUserId.params.userId || '',
      quizId: matchTypeQuizIdUserId.params.quizId,
    };
  } else if (matchTypeQuizId !== null) {
    currentRoute = {
      userId: '',
      quizId: matchTypeQuizId.params.quizId,
    };
  }

  return {
    quizIdFromRoute: (currentRoute.quizId as QUIZ_IDS) || ('' as QUIZ_IDS),
    userIdFromRoute: currentRoute.userId,
  };
};

export default useRouteIds;
